import { Component } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AdminAuthProvider } from "@/context/AdminAuthContext";
import SmoothScroll from "@/components/SmoothScroll";
import ScrollToTop from "@/components/ScrollToTop";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Knowledge from "@/pages/Knowledge";
import Insights from "@/pages/Insights";
import ArticleDetail from "@/pages/ArticleDetail";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";
import NewsletterResult from "@/pages/NewsletterResult";
import NewsletterArchive from "@/pages/NewsletterArchive";
import CategoryPage from "@/pages/CategoryPage";
import GuidePage from "@/pages/GuidePage";
import LogoProposals from "@/pages/LogoProposals";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-navy p-8 text-ivory">
          <div className="max-w-md text-center">
            <p className="font-serif text-3xl italic text-gold">Something went wrong</p>
            <p className="mt-3 text-sm text-ivory/60">{String(this.state.error?.message || this.state.error)}</p>
            <button
              onClick={() => window.location.reload()}
              className="mt-6 border border-gold/50 px-6 py-3 font-mono text-xs uppercase tracking-[0.2em] text-gold-bright hover:bg-gold hover:text-navy"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function SiteLayout() {
  return (
    <>
      <Navbar />
      <main data-testid="site-main">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <LanguageProvider>
        <BrowserRouter>
          <SmoothScroll />
          <ScrollToTop />
          <AdminAuthProvider>
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/advisory" element={<About />} />
                <Route path="/knowledge-center" element={<Knowledge />} />
                <Route path="/insights" element={<Insights />} />
                <Route path="/knowledge-center/:slug" element={<ArticleDetail />} />
                <Route path="/insights/:slug" element={<ArticleDetail />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/newsletter/conferma" element={<NewsletterResult mode="confirm" />} />
                <Route path="/newsletter/cancellati" element={<NewsletterResult mode="cancel" />} />
                <Route path="/newsletter/archivio" element={<NewsletterArchive />} />
                <Route path="/categoria/:slug" element={<CategoryPage />} />
                <Route path="/guida-incoterms" element={<GuidePage />} />
                <Route path="/proposte-logo" element={<LogoProposals />} />
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </AdminAuthProvider>
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" />
      </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
